import React, { useState } from 'react';
import { Tabs, Tab } from '@nextiva/next-ui-components';
import { useSelector } from 'react-redux';

import { TabPanel } from 'components';

import { ShadowRoleForm } from '../../ShadowDom/index';
import Form from '../Form';

const RoleTabs = ({ editPermissions, isLoadingRole }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const roleRequestBody = useSelector(
    (state) => state.rolesPermissions.roleRequestBody,
  );

  const handleChange = (_event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleChange}
        data-testid="PlatformAdminUI-RoleTabs-Tabs"
      >
        {editPermissions.map((tab, i) => (
          <Tab key={i} label={tab.title} />
        ))}
      </Tabs>
      {editPermissions.map(({ macros }, i) => {
        return (
          <TabPanel key={i} value={tabIndex} index={i}>
            {isLoadingRole ? (
              <ShadowRoleForm />
            ) : (
              <Form macros={macros} roleRequestBody={roleRequestBody} />
            )}
          </TabPanel>
        );
      })}
    </>
  );
};

export default RoleTabs;
